import React from "react";
import { useFeatureAccess } from "Hooks/useFeatureAccess";
import { getFeatureByKey } from "Utility/featureUtils";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCrown,
  faLock,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";

const FeatureAccessWrapper = ({ featureKey, children }) => {
  const navigate = useNavigate();
  const { hasAccess } = useFeatureAccess();
  const feature = getFeatureByKey(featureKey);

  // If feature doesn't exist, show error
  if (!feature) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md mx-4 text-center">
          <div className="text-red-500 text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Feature Not Found
          </h2>
          <p className="text-gray-600 mb-6">
            The requested feature could not be found. Please check the URL and
            try again.
          </p>
          <button
            onClick={() => navigate("/dashboard")}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 flex items-center justify-center gap-2 mx-auto"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  // Check if user has access to the feature
  if (!hasAccess(featureKey)) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md mx-4 text-center">
          <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6">
            <FontAwesomeIcon icon={faCrown} className="text-white text-3xl" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            {feature.title}
          </h2>
          <p className="text-gray-600 mb-6">{feature.description}</p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2 text-amber-800 mb-2">
              <FontAwesomeIcon icon={faLock} className="text-amber-600" />
              <span className="font-semibold">Premium Feature</span>
            </div>
            <p className="text-amber-700 text-sm">
              This feature requires a premium subscription. Contact support to
              unlock this feature.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <button
              onClick={() => navigate("/dashboard")}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 flex items-center justify-center gap-2"
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              Back to Dashboard
            </button>
            <button
              onClick={() => window.open("https://wa.me/919106057923", "_blank")}
              className="border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-medium hover:bg-gray-50 transition-colors duration-200"
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>
    );
  }

  // User has access, render the children
  return <>{children}</>;
};

export default FeatureAccessWrapper;
